import React, { useMemo, useState, useEffect } from "react";
import Flexbox from "flexbox-react";


/* =========================================================
 Rating Segments
========================================================= */
const RatingSegments = ({
  rating,
  type
}) => {
  const safeRating = Math.min(5, Math.max(0, Number(rating) || 0));

  return (
    <div className="rating-segments">
      {[1, 2, 3, 4, 5].map(item => {
        let fillPercentage = 0;

        if (safeRating >= item) {
          fillPercentage = 100;
        } else if (safeRating > item - 1) {
          fillPercentage =
            (safeRating - (item - 1)) * 100;
        }

        return (
          <div
            key={item}
            className="rating-segment"
          >
            <div
              className={`rating-segment-fill rating-segment-${type}`}
              style={{
                width: `${fillPercentage}%`
              }}
            />
          </div>
        );
      })}
    </div>
  );
};


/* =========================================================
 Rating Comparison
========================================================= */

const RatingComparison = ({
  selfRating,
  otherRating
}) => {
  const hasSelfRating =
    selfRating !== null &&
    selfRating !== undefined;

  const hasOtherRating =
    otherRating !== null &&
    otherRating !== undefined;

  return (
    <div className="rating-comparison">
      {hasSelfRating && (
        <RatingSegments
          rating={selfRating}
          type="self"
        />
      )}

      {hasOtherRating && (
        <RatingSegments
          rating={otherRating}
          type="other"
        />
      )}
    </div>
  );
};


/* =========================================================
 Rating Pill
========================================================= */



const RatingPill = ({
  value,
  type,
  hidden = false
}) => {

  if (hidden) {
    return (
      <div className="rating-hidden" style={{ textAlign: 'center' }}>
        Scores hidden to preserve anonymity
      </div>
    );
  }

  if (
    value === null ||
    value === undefined
  ) {
    return (
      <div className="rating-pill rating-pill-empty">
        -
      </div>
    );
  }

  return (
    <div className={`rating-pill rating-pill-${type}`}>
      {Number(value).toFixed(1)}
    </div>
  );
};


/* =========================================================
 Response Box
========================================================= */

const ResponseBox = ({
  response
}) => {
  const hasResponse =
    response !== null &&
    response !== undefined &&
    String(response).trim() !== "";

  return (
    <div className="question-response-value">
      {hasResponse
        ? response
        : "-"}
    </div>
  );
};


/* =========================================================
 Other Responses
========================================================= */

const OtherResponses = ({
  answers = []
}) => {
  const validAnswers =
    answers.filter(
      answer =>
        answer &&
        answer.answer !== null &&
        answer.answer !== undefined &&
        String(answer.answer).trim() !== ""
    );

  if (!validAnswers.length) {
    return null;
  }

  return (
    <div className="other-responses">

      <div className="question-response-label push-10-t" >
        Other Responses
      </div>

      <div className="other-responses-list">

        {validAnswers.map(
          (answer, index) => (
            <div
              key={index}
              className="other-response-item"
            >
              <span className="other-response-number">
                {index + 1}.
              </span>

              <span>
                {answer.answer}
              </span>
            </div>
          )
        )}

      </div>

    </div>
  );
};


/* Question Row */

const QuestionRows = ({
  question,
  selfQuestion,
  questionNumber
}) => {

  const answerType =
    question?.answer_type ||
    selfQuestion?.answer_type;

  const isRatingQuestion = answerType === "rating_scale";
  const isOpenTextQuestion = answerType === "open_text";

  const selfRating = selfQuestion?.rating ?? null;

  const selfAnswer = selfQuestion?.answer ?? null;
  const otherRating = question?.avg_question_rating ?? null;

  const otherAnswers = question?.answers || [];


  return (
    <div className="feedback-question-row">

      {/* =================================================
              Question
          ================================================= */}

      <div className="feedback-question-column">

        <Flexbox
          alignItems="flex-start"
        >

          <div className="question-number">
            {questionNumber}
          </div>

          <div className="question-content">

            <div className="question-title">
              {question?.question ||
                selfQuestion?.question ||
                "-"}
            </div>


            {/* =====================================
                          OPEN TEXT
                      ===================================== */}

            {isOpenTextQuestion && (
              <div className="question-response">

                {/* Self response */}

                <div className="question-response-label">
                  Self Response
                </div>

                <ResponseBox
                  response={selfAnswer}
                />


                {/* Other responses */}

                <OtherResponses
                  answers={
                    otherAnswers
                  }
                />

              </div>
            )}

          </div>

        </Flexbox>

      </div>


      {/* =================================================
              Rating Comparison
          ================================================= */}

      <div className="feedback-comparison-column">

        {isRatingQuestion && (
          <RatingComparison
            selfRating={
              selfRating
            }
            otherRating={
              otherRating
            }
          />
        )}

        {isOpenTextQuestion && (
          <div className="feedback-answer-type">

          </div>
        )}
      </div>


      {/* Self Rating*/}
      <div className=" feedback-rating-column  feedback-self-rating " >
        {isRatingQuestion ? (
          <RatingPill value={selfRating} type="self" />
        ) : (
          ""
        )}
      </div>

      {/*Other Rating */}
      <div className="feedback-rating-column feedback-other-rating " >
        {isRatingQuestion ? (
          <RatingPill value={otherRating} type="other" />
        ) : (
          ""
        )}

      </div>

    </div>
  );
};

const QuestionRowerew = ({
  question,
  questionNumber
}) => {

  const isRatingQuestion =
    question?.answer_type === "rating_scale";

  const isOpenTextQuestion =
    question?.answer_type === "open_text";

  const otherAnswers = [
    ...(question.peers?.answers || []),
    ...(question.direct_report?.answers || []),
    ...(question.manager?.answers || [])
  ];

  return (
    <div className="feedback-question-row">

      {/* QUESTION */}
      <div className="feedback-question-column">

        <Flexbox alignItems="flex-start">

          <div className="question-number">
            {questionNumber}
          </div>

          <div className="question-content">

            <div className="question-title">
              {question.question}
            </div>

            {/* =========================
                OPEN TEXT
            ========================= */}
            {isOpenTextQuestion && (
              <div className="question-response">

                {/* Self answer */}
                <div className="question-response-label">
                  Self Response
                </div>

                <ResponseBox
                  response={
                    question.self?.answers?.[0]
                  }
                />

                {/* Other answers */}
                {otherAnswers.length > 0 && (
                  <div className="other-responses">

                    <div className="question-response-label">
                      Other Responses
                    </div>

                    <div className="other-responses-list">

                      {otherAnswers.map(
                        (answer, index) => (
                          <div
                            key={index}
                            className="other-response-item"
                          >
                            <span className="other-response-number">
                              {index + 1}.
                            </span>

                            <span>
                              {answer}
                            </span>
                          </div>
                        )
                      )}

                    </div>

                  </div>
                )}

              </div>
            )}

          </div>

        </Flexbox>

      </div>


      {/* SELF */}
      <div className="feedback-rating-column">
        {isRatingQuestion && (
          <RatingPill
            value={question.self?.rating}
            type="self"
          />
        )}
      </div>


      {/* PEERS */}
      <div className="feedback-rating-column">
        {isRatingQuestion && (
          <RatingPill
            value={question.peers?.rating}
            type="peer"
            hidden={question.peers?.hidden}
          />
        )}
      </div>


      {/* DIRECT REPORT */}
      <div className="feedback-rating-column">
        {isRatingQuestion && (
          <RatingPill
            value={question.direct_report?.rating}
            type="direct-report"
            hidden={question.direct_report?.hidden}
          />
        )}
      </div>


      {/* MANAGER */}
      <div className="feedback-rating-column">
        {isRatingQuestion && (
          <RatingPill
            value={question.manager?.rating}
            type="manager"
            hidden={question.manager?.hidden}
          />
        )}
      </div>


      {/* OVERALL */}
      <div className="feedback-rating-column">
        {isRatingQuestion && (
          <RatingPill
            value={question.overall}
            type="overall"
          />
        )}
      </div>

    </div>
  );
};

const AnswerList = ({
  answers = [],
  hidden = false
}) => {
  if (hidden) {
    return (
      <div className="answer-hidden">
        Scores hidden to preserve anonymity
      </div>
    );
  }

  if (!answers.length) {
    return (
      <div className="answer-empty">
        -
      </div>
    );
  }

  return (
    <div className="question-answer-single">
      {answers.map((answer, index) => (
        <div
          key={`${index}-${answer}`}
          className="question-answer-item"
        >
          <span className="answer-text">
            {answer}
          </span>
        </div>
      ))}
    </div>
  );
};

const RaterCell = ({ answer = {}, answerType, raterKey }) => {
  if (answerType === "rating_scale") {
    return <RatingPill value={answer.ratings?.length ? answer.ratings.reduce((sum, rating) => sum + Number(rating || 0), 0) / answer.ratings.length : null} type={raterKey === "self" ? "self" : "other"} hidden={answer.hidden} />;
  }

  if (raterKey === "self" && !answer.answers?.length) {
    return <RatingPill value={null} type="self" />;
  }

  return <AnswerList answers={answer.answers} hidden={answer.hidden} />;
};

const QuestionRow = ({
  question,
  questionNumber,
  raterKeys = [],
  gridTemplateColumns
}) => {
  const isRatingQuestion = question.answer_type === "rating_scale";

  return (
    <div className="feedback-question-row" style={{ gridTemplateColumns }}>

      <div className="feedback-question-column">

        <Flexbox alignItems="flex-start">

          <div className="question-number">
            {questionNumber}
          </div>

          <div className="question-content">

            <div className="question-title">
              {question.question}
            </div>

          </div>

        </Flexbox>

      </div>

      {raterKeys.map((key) => (
        <div key={key} className={`feedback-rater-column ${isRatingQuestion ? (key === 'self' ? 'feedback-self-rating' : 'feedback-other-rating') : ''}`}>
          <RaterCell answer={question[key]} answerType={question.answer_type} raterKey={key} />
        </div>
      ))}


      {/* OVERALL */}

      <div className="feedback-overall-rating-column feedback-other-rating">
        {isRatingQuestion ? (
          <RatingPill
            value={question.overall}
            type="overall"
          />
        ) : (

          <div className="rating-pill rating-pill-empty">
            -
          </div>

        )}

      </div>


      {/*  RATING COMPARISON*/}

      <div className="feedback-comparison-column">
        {isRatingQuestion && question.overall !== null && question.overall !== undefined ? (
          <RatingComparison
            selfRating={question.self?.ratings?.[0]}
            otherRating={question.overall}
          />
        ) : <div className="rating-pill rating-pill-empty">-</div>}
      </div>

    </div>
  );
};


/* Assessment Header*/

const AssessmentHeader = ({
  assessment,
  selfAssessment,
  isExpanded,
  onToggle
}) => {
  const isSelfAssessment =
    assessment.id === "self";

  const selfRating = isSelfAssessment
    ? assessment.final_rating ??
    assessment.avg_rating ??
    null
    : selfAssessment?.final_rating ??
    selfAssessment?.avg_rating ??
    null;

  const otherRating = isSelfAssessment
    ? null
    : assessment.peer_avg_rating ??
    assessment.avg_rating ??
    null;

  return (
    <div
      className={`assessment-header ${isExpanded
        ? "assessment-header-expanded"
        : ""
        }`}
      onClick={onToggle}
    >
      <div className="assessment-title-column">
        <span className="assessment-arrow">
          {isExpanded ? "⌄" : "›"}
        </span>

        <span className="assessment-title">
          {assessment.title}
        </span>
      </div>

      <div className="assessment-comparison-column">
        <RatingComparison
          selfRating={selfRating}
          otherRating={otherRating}
        />
      </div>

      <div className="assessment-rating-column">
        <RatingPill
          value={selfRating}
          type="self"
        />
      </div>

      <div className="assessment-other-rating-column">
        <RatingPill
          value={otherRating}
          type="other"
        />
      </div>
    </div>
  );
};

const EmptyAssessment = () => {
  return (
    <div className="feedback-empty-assessment">
      No responses submitted.
    </div>
  );
};




const UserFormBrief360Report = ({ feedbackData = [], isLoading = false }) => {


  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    const initialState = {};

    feedbackData.forEach(assessment => {
      initialState[assessment.id] = true;
    });
    setExpandedSections(initialState);
  }, [feedbackData]);

  const toggleSection = id => {
    setExpandedSections(
      previous => ({
        ...previous,
        [id]:
          !previous[id]
      })
    );
  };

  if (isLoading) {
    return (
      <div className="feedback-form-report">

        <div className="feedback-loading">
          Loading review responses...
        </div>

      </div>
    );
  }


  /* =======================================================
     No Data
  ======================================================= */

  if (!feedbackData.length) {
    return (
      <div className="feedback-form-report">

        <div className="feedback-empty">
          No feedback data found.
        </div>

      </div>
    );
  }

  const raterKeys = Array.from(new Set(feedbackData.flatMap((question) => Object.keys(question || {}))))
    .filter((key) => !["id", "question", "answer_type", "overall"].includes(key))
    .sort((left, right) => left === "self" ? -1 : right === "self" ? 1 : 0);
  // Let the columns share the available table width, while keeping enough
  // room for readable responses. The table can scroll when those minimums
  // no longer fit (for example, with many raters or on a narrow screen).
  const raterShare = (68 / raterKeys.length).toFixed(4);
  const raterOffset = (197.2 / raterKeys.length).toFixed(2);
  const gridTemplateColumns = `minmax(220px, calc(32% - 92.8px)) repeat(${raterKeys.length}, minmax(110px, calc(${raterShare}% - ${raterOffset}px))) 110px 180px`;


  return (
    <div className="feedback-form-report">
      <Flexbox
        alignItems="center"
        className="feedback-form-heading"
      >

        <div className="feedback-form-icon">
          ✓
        </div>

        <div>
          <div className="feedback-form-title">
            Review Form
          </div>

          <div className="feedback-form-description">
            Submitted review responses.
          </div>

        </div>

      </Flexbox>

      <div className="feedback-readonly-banner">

        <span className="feedback-readonly-icon">
          ♧
        </span>

        This review has been submitted and is
        now in read-only mode. You cannot make
        any further changes.

      </div>


      {/* Table */}
      <div className="feedback-table">

        {/* Table Header*/}

        <div className="feedback-table-header" style={{ gridTemplateColumns }}>

          <div className="feedback-question-header">
            Question
          </div>

          {raterKeys.map((key) => (
            <div key={key} className="feedback-rater-header">
              {key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase())}
            </div>
          ))}

          <div className="feedback-overall-rating-header">
            Overall
          </div>

          <div className="feedback-comparison-header">
            Rating Comparison
          </div>

        </div>

        {feedbackData.map((question, index) => (

          <QuestionRow
            key={question.id}
            question={question}
            questionNumber={index + 1}
            raterKeys={raterKeys}
            gridTemplateColumns={gridTemplateColumns}
          />

        ))}



      </div>

    </div>
  );
};


export default UserFormBrief360Report;
